exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.code-block[data-v-5d384c02] .CodeMirror {\n    height: auto;\n}\n.block-toolbar[data-v-5d384c02] {\n    margin: 0;\n    width: 100%;\n}\n.block-toolbar .button[data-v-5d384c02] {\n    margin: 0;\n}\n", ""]);

// exports
